import React, { PureComponent } from 'react'
import { pure } from 'recompose'
import { connect } from 'react-redux'
import { Route, Switch, withRouter } from 'react-router-dom'
import { withTheme } from 'material-ui-next/styles'
import withStyles from 'material-ui-next/styles/withStyles'
import {
  AuthRoute,
  MaybeAuthRoute,
  MaybeAuthRouteWithTopBar,
  GuestRoute,
} from './routing'

import Home from './pages/Home'
import Profile from './pages/Profile'
import Login from './pages/Login'
import Register from './pages/Register'
import PasswordRecover from './pages/PasswordRecover'
import Help from './pages/Help'
import World from './pages/World'
import AllWorlds from './pages/AllWorlds'
import Category from './pages/Category'
import ObjectDetail from './pages/ObjectDetail'
import Messages from './pages/Messages/Messages'
import User from './pages/User/User'
import Prova from './pages/Prova'
import ScaricaApp from './pages/ScaricaApp'
import ComeFunziona from './pages/ComeFunziona'
import Me from './pages/Me/Me'
import AddItem from './pages/AddItem'
import NotFoundPage from './pages/NotFoundPage'
import NewSwap from './pages/NewSwap'
import SwapDetail from './pages/SwapDetail'
import EditProfile from './pages/EditProfile'
import DeleteAccount from './pages/DeleteAccount'
import ChangePassword from './pages/ChangePassword'
import PieghiDiLibri from './pages/PieghiDiLibri'
import Notifications from './pages/Notifications'
import AcceptTerms from './pages/AcceptTerms'

import TopBar from './common/TopBar'
import CookieConsent from './common/CookieConsent'
import NotificationQueue from './common/NotificationQueue'

import { getCategories, getDistricts } from './actions'
import MediaQuery from 'react-responsive'
import breakpoints from './styles/breakpoints'
import { getTopBarConfig } from './selectors'

// TODO: Implement padding using shitty classes for animate filters opening...
// const styles = theme => ({
//   'padding-toolbar': {
//     paddingTop: theme.swapick.dimensions.toolbar,
//   }
// })

let Padder = ({
  children,
  theme,
  topBarExpandable,
  topBarHasToolbar,
  openFilters,
  filtersLines,
}) => (
  <MediaQuery maxWidth={breakpoints.xs}>
    {isMobile => {
      // ~~~ Base padding from top
      let paddingTop = 15

      if (topBarExpandable && !isMobile) {
        paddingTop += theme.swapick.dimensions.toolbarExpanded
      } else {
        paddingTop += theme.swapick.dimensions.toolbar
      }

      if (topBarHasToolbar) {
        paddingTop += theme.swapick.dimensions.secondaryToolbar
      }

      // When on mobile no need to chunks filters into multi lines
      if (openFilters && !isMobile) {
        paddingTop +=
          theme.swapick.dimensions.filtersToolbar * Math.max(+filtersLines, 1)
      }

      return <div style={{ paddingTop }}>{children}</div>
    }}
  </MediaQuery>
)

const mapStateToProps = state => {
  const config = getTopBarConfig(state)
  return {
    topBarExpandable: config.expandable,
    topBarHasToolbar: !!config.toolbar,
    openFilters: config.openFilters,
    filtersLines: config.filtersLines,
  }
}

Padder = withTheme()(connect(mapStateToProps)(pure(Padder)))
// Padder = withStyles(styles)(connect(mapStateToProps)(pure(Padder)))

class Swapick extends PureComponent {
  componentDidMount() {
    this.props.getDistricts()
    this.props.getCategories()
  }

  render() {
    return (
      <div>
        <TopBar />
        <NotificationQueue />

        <Padder>
          <Switch>
            <GuestRoute path="/login" component={Login} />
            <GuestRoute path="/register" component={Register} />
            <GuestRoute path="/password-recover" component={PasswordRecover} />

            <MaybeAuthRouteWithTopBar
              path="/"
              exact
              component={Home}
              topBar={{
                toolbar: 'WorldsToolbar',
                title: 'Swapick',
                expandable: true,
              }}
            />
            <MaybeAuthRouteWithTopBar
              path="/world/:world"
              component={World}
              topBar={{
                expandable: false,
                toolbar: 'WorldToolbar',
                hasFilters: true,
                topSearch: true,
                titleDropdownWorlds: true,
                filtersLines: 1,
              }}
            />
            <MaybeAuthRouteWithTopBar
              path="/all-worlds"
              component={AllWorlds}
              topBar={{
                expandable: false,
                toolbar: 'AllWorldsToolbar',
                hasFilters: true,
                topSearch: true,
                filtersLines: 1,
                titleDropdownWorlds: true,
              }}
            />
            <MaybeAuthRouteWithTopBar
              path="/category/:category"
              component={Category}
              topBar={{
                expandable: false,
                toolbar: 'CategoryToolbar',
                hasFilters: true,
                topSearch: true,
                titleDropdownWorlds: true,
              }}
            />
            <MaybeAuthRouteWithTopBar
              path="/item/:id"
              component={ObjectDetail}
              topBar={{
                toolbar: 'WorldsToolbar',
                expandable: false,
              }}
            />
            <AuthRoute path="/user/:username" component={User} />

            <AuthRoute path="/profile/edit" component={EditProfile} />
            <AuthRoute
              path="/profile/change-password"
              component={ChangePassword}
            />
            <AuthRoute
              path="/profile/delete-account"
              component={DeleteAccount}
            />
            <AuthRoute path="/profile" component={Profile} />
            <AuthRoute path="/me" component={Me} />
            <AuthRoute path="/swap/new/:destinatarioId" component={NewSwap} />
            <AuthRoute path="/swap/:id" component={SwapDetail} />
            <AuthRoute path="/messages" component={Messages} />
            <AuthRoute path="/notifications" component={Notifications} />
            <AuthRoute path="/add" component={AddItem} />

            <Route path="/scarica-app" component={ScaricaApp} />
            <Route path="/come-funziona" component={ComeFunziona} />
            <Route path="/pieghi-di-libri" component={PieghiDiLibri} />
            <Route path="/help" component={Help} />
            <Route path="/accept-new-terms" component={AcceptTerms} />

            {/* DEBUG */}

            {process.env.NODE_ENV !== 'production' && (
              <Route path="/prova" component={Prova} />
            )}

            {/* DEFAULT PAGE */}
            <Route component={NotFoundPage} />
          </Switch>
        </Padder>
        <CookieConsent />
      </div>
    )
  }
}

export default withRouter(
  connect(undefined, {
    getCategories,
    getDistricts,
  })(Swapick)
)



// WEBPACK FOOTER //
// ./src/Swapick.js